/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Plan } from '@touchplan/common';
import { FancyFirebaseObject } from '../base/FancyFirebaseObject';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';

export class PlanObject extends FancyFirebaseObject<Plan> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable) {
		super(angularLand, path);
	}

	public $$updated(child: any) {
		if (!child || !child.payload.exists()) {
			return null;
		}

		const plan = new Plan(child.payload.key);
		plan.databaseUpdate(child.payload.val());
		return plan;
	}

	//placeholder
	public updateTicketCount(count) {
		return this.listRef.query.ref.child('ticketCount').set(count);
	}
}
